import React, { useState }  from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import qs from 'qs'
import ReactHtmlParser, { convertNodeToElement } from 'react-html-parser';
import Button from '~components/button/button.component';
import { postUrl } from '~common/legacy-helpers';

import {
  KEY_CODES
} from '~constants';

import useStyles from './search-organizations.styles';

const SearchOrganizations = props => {
  const classes = useStyles(props);

  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState(null);

  const onSearch = async event => {
    event.preventDefault();
    try {
      const data = await postUrl(
        'https://www.rainedout.net/search.php', {
        search: 'Search',
        category: 0,
        search_term: searchTerm
      }
      );
      setSearchResults(data);
    } catch (error) {
      console.error(error);
    }
  }

  const transformSearchResults = (node, index) => {

    const isTag = node.type === 'tag';
    const isHiddenElementId = id => ['left', 'right', 'search_area', 'logo', 'lower'].indexOf(id) !== -1;
    const isHiddenElementClass = className => ['accessible', 'title', 'tabs'].indexOf(className) !== -1;
    const isHiddenElementTag = nodeName => ['meta', 'title'].indexOf(nodeName) !== -1;

    if (isTag && node.name === 'html') {
      // Remove all xmls validation tags and convert to div
      node.name = 'div';
      node.attribs = {};
      return convertNodeToElement(node, index, transformSearchResults);
    } else if (isTag && node.name === 'head') {
      // Convert to div
      node.name = 'div';
      return convertNodeToElement(node, index, transformSearchResults);
    } else if (isTag && node.name === 'body') {
      // Convert to div
      node.name = 'div';
      return convertNodeToElement(node, index, transformSearchResults);
    } else if (isTag && node.name === 'link') {
      // Remove all style tags and convert to div
      node.name = 'div';
      node.attribs = {};
      return convertNodeToElement(node, index, transformSearchResults);
    } else if (isTag && node.name === 'p') {
      node.name = 'div';
      return convertNodeToElement(node, index, transformSearchResults);
    } else if (isTag && node.name === 'a' && node.attribs.class === 'search_result_link') {
      // Grab the link text
      const organizationName = node.children[0].data;

      // Grab the original link href, parse the querystring ("a") to get the org id and stash it in component state.
      const organizationUrl = new URL(node.attribs.href, "https://www.rainedout.net/").search;
      const organizationId = qs.parse(organizationUrl, { ignoreQueryPrefix: true }).a;
      return (
        <div
          key={index}
          className='organization'
          onClick={event => {
            event.preventDefault();
            props.onSelectedOrganizationChange(organizationId, organizationName)
          }}
          onKeyDown={event => {
            if (event.keyCode === KEY_CODES.ENTER) {
              event.preventDefault();
              props.onSelectedOrganizationChange(organizationId, organizationName)
            }}
          }
          role="link"
          tabIndex={0}
        >
          {convertNodeToElement (node, index, transformSearchResults)}
        </div>
      )
    } else if (isTag && (isHiddenElementTag(node.name) || isHiddenElementId(node.attribs.id) || isHiddenElementClass(node.attribs.class))) {
      return null;
    }
  }

  return (
    <div
      className={classNames(
        [classes.searchOrganizations],
        {
          [props.className]: !!props.className
        }
      )}
    >
      <form name="searchOrganization" onSubmit={event => onSearch(event)}>
        <div className={classes.inputField}>
          <input className={classes.input} placeholder="Search Orgs…" type="text" value={searchTerm} onChange={event => setSearchTerm(event.target.value)}/>
        </div>
        <Button
          className={classes.button}
          onClick={event => onSearch(event)}
          iconRight="search"
          shadow={true}
          size="small"
          text="Search"
          theme="blue"
        />
      </form>
      {searchResults ? <div className={classes.searchResults}>{ReactHtmlParser(searchResults, { transform: transformSearchResults })}</div> : null}
    </div>
  )
}

SearchOrganizations.propTypes = {
  onSelectedOrganizationChange: PropTypes.func.isRequired,
}

SearchOrganizations.defaultProps = {}

export default SearchOrganizations
